import { Checkbox, Chip, styled, Table, TableCell, TableRow } from '@mui/material';
import { STATUS_COLORS } from 'dashboard409a/pages/Workboard/common/constants';

const getStatusColor = (status?: string) => {
  if (!status) {
    return '#E3F2FD';
  }

  const normalizedStatus = status.toLowerCase();

  const matchingColor = Object.entries(STATUS_COLORS).find(([key]) => key.toLowerCase() === normalizedStatus);

  return matchingColor ? matchingColor[1] : '#E3F2FD';
};

const RootContainer = styled('div')(() => ({
  width: '100%',
}));

const StyledTable = styled(Table)(() => ({
  minWidth: 750,
}));

const StyledCheckbox = styled(Checkbox)(() => ({}));

const StyledTableRow = styled(TableRow)(() => ({
  height: '33px',
  cursor: 'pointer',
}));

const StyledTableCell = styled(TableCell)(() => ({
  padding: '6px',
  fontSize: '14px',
}));

const StyledTableCellEmptyMessage = styled(TableCell)(({ theme }) => ({
  textAlign: 'center',
  padding: `${theme.spacing(3)} ${theme.spacing(2)}`,
  fontSize: '16px',
  color: theme.palette.primary.main,
}));

interface StatusChipProps {
  status?: string;
}

const StyledStatusChip = styled(Chip)<StatusChipProps>(({ theme, status }) => ({
  backgroundColor: getStatusColor(status),
  color: theme.palette.common.black,
  borderRadius: '10px',
  padding: `0px ${theme.spacing(1.5)}`,
  fontSize: '14px',
}));

const StyledSpanEmptyStatus = styled('span')(({ theme }) => ({
  fontSize: '14px',
  color: theme.palette.common.black,
}));

export {
  RootContainer,
  StyledTable,
  StyledCheckbox,
  StyledTableRow,
  StyledTableCell,
  StyledTableCellEmptyMessage,
  StyledStatusChip,
  StyledSpanEmptyStatus,
};
